module.exports = __webpack_public_path__ + "img/MrSpeedy.188868e3.png";